export default file => {
  return resolve => {
    require([`@/${file}`], resolve);
  };
};